module.exports = __webpack_public_path__ + "static/sanofi-second-logo-fr-038411327f5f1c472c1997299afdcda3.png";